import type { IMarket } from "~/types/event";

const normalize = (value: string): string => value.trim().toLowerCase();

export const getEmbedTitle = (
  markets: IMarket[],
  eventTitle: string
): string => {
  const [first] = markets;

  if (!first) return eventTitle;

  const outcomes = new Set(markets.map(({ title }) => normalize(title ?? "")));

  if (outcomes.size > 1) return eventTitle;

  return first.question || eventTitle;
};
